/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import LoadingSkeleton from "../LoadingSkeleton/LoadingSkeleton";
import { WhoAmI } from "../api/modal";
import { useEffect, useState } from "react";
import { useSafeLocation } from "../hooks/useSafeRouter";

export const PrivateRoute = () => {
  const location = useSafeLocation();
  let { data: user, isLoading } = useUser();
  const [localUser, setLocalUser] = useState<WhoAmI | null>(null);    
  const isDev = process.env.NODE_ENV === 'development';

  useEffect(() => {
    console.log("Private Route User: ", user);
    if (isDev) {
      setLocalUser({
        status: "OK",
        statuscode: 200,
        result: {
          id: "874dd0c1-b4c3-ee11-9079-002248933aab",
          firstname: "Harry",
          lastname: "Singh",
          fullname: "Harry Singh",
          email: "harry.singh@nz.harveynorman.com",
          mainphone: "01122233333",
          mobile: "+6421629625",
          avartar: "/_services/badges/7b138792-1090-45b6-9241-8f8d96d8c372/874dd0c1-b4c3-ee11-9079-002248933aab/basic-badges",
          rolls: ["Customer with Scope to Self", "Customer with Scope to Account (Web Admin)", "Customer with Scope to Account", "Deliver Easy Agent", "Deliver Easy Agent Admin", "Administrators", "Anonymous"],
          lastmodifiedon: "2024-05-23T01:51:56-UTC",
          account: {
            accountid: "acddbc94-0b74-ed11-81ac-00224893377f",
            companyname: "#Test Limited",
            registeredname: "Test Limited",
            nzbn: "9429037583194",
            pricelistid: "b1d1d23a-2623-ed11-9db1-00224891e38d",
            lastmodifiedon: "2024-04-11T00:19:50-UTC"
          }
        }
      });
    }
  }, []);


  console.log("Private Route User: ", user);

  if (isLoading) {
    return <LoadingSkeleton message="Loading..." />;
  }

  if (isDev) {
    console.log("Local User: ", localUser);
    return !localUser ? (
      <Navigate replace to={"/"} state={{ from: location }} />
    ) : (
      <Outlet />
    );
  }

  return !user?.result.id ? (
    <Navigate replace to={"/"} state={{ from: location }} />
  ) : (
    <Outlet />
  );
};